import axiosInstance from '../AxiosClient'
import { notificationShape, notificationUpdateShape } from './models'
import {
  createApi,
  createCustomServiceCall,
  createCollectionManager,
  Pagination,
} from '@thinknimble/tn-models'
import { z } from 'zod'

const NOTIFICATIONS_ENDPOINT = '/notifications/'

// API functions
const markAsRead = createCustomServiceCall(
  {
    inputShape: notificationUpdateShape,
    outputShape: notificationShape,
  },
  async ({ client, utils, input }) => {
    const data = utils.toApi(input)
    const res = await client.patch(`${NOTIFICATIONS_ENDPOINT}${data.id}/`, {
      read_status: data.read_status,
    })
    return utils.fromApi(res.data)
  },
)

// Create the main API
export const NotificationApi = createApi(
  {
    baseUri: NOTIFICATIONS_ENDPOINT,
    client: axiosInstance,
    models: {
      entity: notificationShape,
    },
  },
  {
    markAsRead,
  },
)

// SHARED COLLECTION INSTANCE
let sharedNotificationCollection = null
let loadingPromise = null
let isDataLoaded = false

/**
 * Reset notification state - called when user logs out
 * This ensures fresh data is loaded when user logs in again
 */
export const resetNotificationState = () => {
  sharedNotificationCollection = null
  loadingPromise = null
  isDataLoaded = false
  console.log('Notification state reset')
}

export const loadNotificationsOnce = async () => {
  // If already loading, wait for the existing promise to avoid duplicate API calls
  if (loadingPromise) {
    await loadingPromise // Wait for loading to complete
    return sharedNotificationCollection // Return the collection, not the promise
  }

  // Create collection if it doesn't exist
  if (!sharedNotificationCollection) {
    sharedNotificationCollection = createCollectionManager({
      fetchList: NotificationApi.list,
      pagination: new Pagination(),
    })
  }

  // If not loaded, start loading and store the promise
  if (!isDataLoaded) {
    loadingPromise = sharedNotificationCollection.refresh()
    await loadingPromise
    isDataLoaded = true
    loadingPromise = null // Clear the promise when done
  }

  return sharedNotificationCollection
}

export const notificationFunctions = () => {
  return {
    api: NotificationApi, // Direct API access
    loadNotificationsOnce, // Shared loader function
    resetNotificationState, // Reset function for logout
  }
}
